import React, { ReactNode } from 'react'
import { Box, Group, Title, Breadcrumbs, Anchor } from '@mantine/core'
import { Link } from 'react-router-dom'
import SidebarLayout from './SidebarLayout'

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface Props {
  title: string;
  breadcrumbs?: BreadcrumbItem[];
  actions?: ReactNode;
  children: ReactNode;
  sidebar?: ReactNode;
}

export default function Page ({
  title,
  breadcrumbs = [],
  actions,
  children,
  sidebar
}: Props) {
  const breadcrumbElements =
    breadcrumbs.length > 0
      ? (
      <Breadcrumbs mb="sm">
        {breadcrumbs.map((item, i) =>
          item.href
            ? (
            <Anchor key={i} component={Link} to={item.href} size="sm">
              {item.label}
            </Anchor>
              )
            : (
            <span key={i} style={{ fontSize: 14, color: 'var(--mantine-color-dimmed)' }}>
              {item.label}
            </span>
              )
        )}
      </Breadcrumbs>
        )
      : null

  const content = (
    <Box
      sx={{
        maxWidth: 1280,
        marginLeft: 'auto',
        marginRight: 'auto',
        paddingLeft: 24,
        paddingRight: 24,
        '@media (max-width: 768px)': {
          paddingLeft: 16,
          paddingRight: 16
        }
      }}
    >
      <Group
        position="apart"
        align="flex-start"
        mb="md"
        sx={{ flexWrap: 'wrap', gap: 8 }}
      >
        <Box>
          {breadcrumbElements}
          <Title order={3}>{title}</Title>
        </Box>
        {actions && <Box>{actions}</Box>}
      </Group>
      {sidebar
        ? (
        <SidebarLayout main={children} sidebar={sidebar} />
          )
        : (
            children
          )}
    </Box>
  )

  return content
}
